import { render, staticRenderFns } from "./ehc-menu.vue?vue&type=template&id=0398895a&scoped=true"
import script from "./ehc-menu.vue?vue&type=script&lang=js"
export * from "./ehc-menu.vue?vue&type=script&lang=js"
import style0 from "./ehc-menu.vue?vue&type=style&index=0&id=0398895a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0398895a",
  null
  
)

export default component.exports